var hotelListItem = {
	data: {
		pageWidth: Math.max(html.clientWidth, win.innerWidth || 0),
		sharedState: { 
			currencyDisplay: {
		      decimalSeparator: '.'
	  		}
	  	}
	},
	methods: {
		getHotelImageUrl: function(url) {
			var size = '290x145'; // ratio 1:2

			if (this.pageWidth > 320 && this.pageWidth <= 375) {
				size = '345x173';
			} else if (this.pageWidth > 375 && this.pageWidth < 768) {
				size = '384x192';
			} else if (this.pageWidth >= 768) {
				size = '200x150';
			}
			return this.imageUrl(size, url);
		},
		getPriceUnit: function() {
			var unit = this.i18n.perRoomPerNight;
			if (!this.sharedState.nightlyRates && !this.withoutAvailability) {
				var startDate = win.calendar.parseDate(this.sharedState.query.start),
					endDate = win.calendar.parseDate(this.sharedState.query.end),
					nights = win.calendar.diffDays(endDate, startDate);
				unit = this.i18n.for + ' ' + nights + ' ' + this.i18n.night[nights == 1 ? 0 : 1];
			}
			return unit;
		},
		getDistance: function(distanceMeter) {
			var distanceKm = distanceMeter / 1000;
           if (this.sharedState.country == 'us') {
                var distanceMiles = distanceKm * 0.62137;
                return (distanceMiles > 1) ? Math.round(distanceMiles * 10) / 10 + ' mi' : Math.round(distanceMiles * 5280) + ' ft';
            } else {
                return (distanceKm > 1) ? Math.round(distanceKm * 10) / 10 + ' km' : Math.round(distanceMeter) + ' m';
            }
        },
        hasFreeWifi: function(amenities) {
        	for (var i = 0; i < amenities.length; i++) {
        		if (amenities[i].id == '2403' || amenities[i].id == '2390') {
        			return amenities[i].description;
        		}
        	}
        },
        guestReviewRating: function(score) {
        	return score.toFixed(1).replace('.', this.sharedState.currencyDisplay.decimalSeparator);
        },
        guestRatingLabel: function(score) {
			var label = "";
			for (var range = 0; range < win.guestReviewRanges.length; range++) {
				if (score >= win.guestReviewRanges[range]) {
					label = this.i18n.guestRatingLabels[range];
					break;
				}
			}
			return label;
	    },
	    hotelClick: function(event, url) {
	    	if (event.target.tagName !== 'A' && event.target.parentElement.tagName !== 'A') {
		    	document.location.href = url;
		    }
	    }
	}
};